import { Collapse, Divider } from 'antd';
import type { FC } from 'react';
import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { Line } from 'app/components/pages/GiftCards/details/Line/Line';
import { type Refund } from 'app/typings/adminBookings/bookingRefund';
import { dateAndHour } from 'app/utils/dates';

import './Refunds.scss';

const { Panel } = Collapse;

export const Refunds: FC<Props> = ({ refunds }) => {
  const { currencyFormatter } = useContext(CurrencyContext);

  const renderHeader = (refund: Refund) =>
    `Refund - ${dateAndHour(refund.createdAt)} - ${currencyFormatter(
      refund.amountCb + refund.amountGiftCard + refund.amountCredit
    )}`;

  return (
    <div className="bloc refunds-booking">
      <Collapse accordion>
        {refunds.map((refund) => {
          const totalRefund =
            refund.amountCb + refund.amountGiftCard + refund.amountCredit;

          return (
            <Panel header={renderHeader(refund)} key={refund.id}>
              <Line
                title="Total Refund"
                value={currencyFormatter(totalRefund)}
              />
              <div className="sublines">
                <Line
                  title="Credit card refund"
                  value={currencyFormatter(refund.amountCb)}
                />
                <Line
                  title="Gift card refund"
                  value={currencyFormatter(refund.amountGiftCard)}
                />
                <Line
                  title="Credit refund"
                  value={currencyFormatter(refund.amountCredit)}
                />
              </div>
              <Divider />
              <Line
                title="Amount due by hotel"
                value={currencyFormatter(refund.refundedFromHotel)}
              />
              <Line
                title="Amount due by Staycation"
                value={currencyFormatter(
                  totalRefund - (refund.refundedFromHotel ?? 0)
                )}
              />
              <Divider />
              <Line title="Paid by" value={refund.source} />
              <Divider />
              <Line title="Created at" value={dateAndHour(refund.createdAt)} />
              <Line title="Created by" value={refund.userName} />
              <Line title="Reason type" value={refund.reason} />
              <Line
                title="Comment"
                value={!!refund.comment?.trim() ? refund.comment : '-'}
              />
            </Panel>
          );
        })}
      </Collapse>
    </div>
  );
};

type Props = {
  refunds: Refund[];
};
